/** Fixed display order of the tiers in the results panel. */
export var TIER_ORDER = ['STRUCTURE', 'VOCABULARY', 'LOGIC'];
export var codeToTier = function (code) {
    if (code.startsWith('ALLOWED'))
        return 'STRUCTURE';
    if (code.startsWith('VOCAB'))
        return 'VOCABULARY';
    return 'LOGIC';
};
/**
 * Group the flat error/warning lists from a `ValidationResult` into the three
 * tiers, preserving the fixed display order and severity split.
 */
export var groupByTier = function (errors, warnings) { return TIER_ORDER.map(function (tier) { return ({
    tier: tier,
    errors: errors.filter(function (i) { return codeToTier(i.code) === tier; }),
    warnings: warnings.filter(function (i) { return codeToTier(i.code) === tier; }),
}); }); };
